export interface BadgeConfig {
  type: BadgeType;
}

export enum BadgeType {
  Small = 'small',
  Large = 'large',
  Dot = 'dot',
}
